import { calendarEventConstants } from "../../_constants";

const initialState = {};

// mentor event details
export const get_calendar_event_details_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_EVENT_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_DETAILS_ACTION_SUCCESS:
    case calendarEventConstants.CREATE_CALENDAR_EVENT_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarEventData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_event_availability_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_EVENT_AVAILABILITY_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
    case calendarEventConstants.UPDATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
    case calendarEventConstants.CREATE_CALENDAR_EVENT_AVAILABILITY_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarEventAvailabilityData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_AVAILABILITY_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_event_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_EVENT_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarEventListsData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_scheduled_event_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarScheduledEventListsData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_upcoming_scheduled_event_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarUpcomingScheduledEventListsData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_UPCOMING_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_past_scheduled_event_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarPastScheduledEventListsData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_PAST_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


// mentor event details
export const get_calendar_unregistered_user_scheduled_event_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
       unregisteredUserCalendarScheduledEventListsData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_UNREGISTERED_USER_SCHEDULED_EVENT_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_event_link_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.GET_CALENDAR_EVENT_LINK_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_LINK_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarEventLinkData: action.payload,
      };
    case calendarEventConstants.GET_CALENDAR_EVENT_LINK_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const assign_calendar_event_link_to_candidate_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarEventConstants.ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarEventConstants.ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        assignedCalendarEventLinkData: action.payload,
      };
    case calendarEventConstants.ASSIGN_CALENDAR_EVENT_LINK_TO_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
